/**
 * The candidate-facing job title. A built-in, not an alias of the ATS job's own `external_name`
 * attribute: resolved value maps carry it as `job_name`, its deprecated alias, and the backend
 * substitutes it from that key wherever `job_name` is substituted.
 */
export const JOB_EXTERNAL_NAME_VARIABLE = 'job.external_name';
export const JOB_EXTERNAL_NAME_TAIL = 'external_name';
export const JOB_INTERNAL_NAME_VARIABLE = 'job.internal_name';
export const JOB_INTERNAL_NAME_TAIL = 'internal_name';
export const JOB_NAME_VALUE_KEY = 'job_name';

export const JOB_AI_NAME_VARIABLE = 'job.ai_name';
export const AI_NAME_VALUE_KEY = 'ai_name';
export const AI_NAME_LEGACY_KEY = 'AI_name';

export const JOB_HIRING_COMPANY_NAME_VARIABLE = 'job.hiring_company_name';
export const JOB_HIRING_COMPANY_NAME_TAIL = 'hiring_company_name';
export const COMPANY_NAME_VALUE_KEY = 'company_name';
export const LEGACY_COMPANY_NAME_FALLBACK_KEY = '_legacy_company_name';

export const CANDIDATE_FULL_NAME_VARIABLE = 'candidate.full_name';
export const CANDIDATE_FIRST_NAME_VARIABLE = 'candidate.first_name';
// Deprecated name for `candidate.first_name`; value maps carry it with the nameless greeting.
export const CANDIDATE_NAME_VALUE_KEY = 'candidate_name';

export const CANDIDATE_PHONE_NUMBER_VARIABLE = 'candidate.phone_number';
export const CANDIDATE_PHONE_NUMBER_VALUE_KEY = 'candidate_phone_number';
export const CANDIDATE_PHONE_LEGACY_KEY = 'candidate_phone';

export const CALL_INTERVIEW_LINK_VARIABLE = 'call.interview_link';
export const INTERVIEW_LINK_VALUE_KEY = 'interview_link';

export const CALL_ESTIMATED_DURATION_MINUTES_VARIABLE =
  'call.estimated_duration_minutes';
export const ESTIMATED_DURATION_MINUTES_VALUE_KEY =
  'estimated_duration_minutes';

export const CALL_EXPIRATION_DAYS_VARIABLE = 'call.expiration_days';
export const EXPIRATION_DAYS_VALUE_KEY = 'expiration_days';

export const CALL_RECRUITER_PHONE_NUMBER_VARIABLE =
  'call.recruiter_phone_number';
export const RECRUITER_PHONE_NUMBER_VALUE_KEY = 'recruiter_phone_number';

export const FOLLOWUP_INTERVIEWER_NAME_VARIABLE = 'followup.interviewer_name';
export const INTERVIEWER_NAME_VALUE_KEY = 'interviewer_name';

export const FOLLOWUP_INTERVIEWER_EMAIL_VARIABLE = 'followup.interviewer_email';
export const INTERVIEWER_EMAIL_VALUE_KEY = 'interviewer_email';
